import React from "react";
import { FormSubSections, ProgramContainer } from "../../entities/formTemplateDataType";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { getSectionElementByFieldName } from "../../utilities/ElementUtils";
import { TextElementDisplayStyle } from "../../entities/Constants";
import { DialogBase } from "./DialogBase";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import Utils from "../../utilities/Utils";

interface Props {
   // programContainer: ProgramContainer
    formSubSections: FormSubSections;
    isEng: boolean;
    dialogVisible:boolean;
    callback;
}

interface State {
    pickedFieldOptions;
}

export class DialogForSubSectionPropertyComponent extends DialogBase<Props,State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            pickedFieldOptions: [],
        };
    }

    componentDidMount(): void {
        if(this.props.formSubSections.FilterField!=null){
            this.onChangeHanlder(this.props.formSubSections.FilterField)
        }
    }
  

    onChangeHanlder = (newValue) => {
   
        let totalOption = [];
        const formSection = this.props.formSubSections.parent;
        const formListPrior = formSection.ListOfFormSubSections.filter(p => p.Sequence < this.props.formSubSections.Sequence);
        formListPrior.forEach((subSection) => {
            let pickedField = subSection.ListOfFormSectionElements.filter(ele => ele.LoadBindName == newValue);

            if(pickedField.length>0){
                let options = pickedField[0].ListOfLOVValues?.map(p => ({
                    code: p.code,
                    description: this.props.isEng? p.description:p.FRADescription
                  }));
                totalOption.push(...options);
            }

        });

        this.setState({ pickedFieldOptions: totalOption });
      //  this.props.callback();
    }

    generateFilter = () => {
        let html = [];
        let elementListWithOptions = [];
        const formSection = this.props.formSubSections.parent;
        //get the section list prior to this one
        let formList =formSection.ListOfFormSubSections.filter(p=>p.Sequence<this.props.formSubSections.Sequence)


        formList.forEach((subSection) => {
            let list = subSection.ListOfFormSectionElements.filter(
                (q) =>
                    (q.Datatype === "RadioButton" ||
                        q.Datatype === "CheckGroup" ||
                        q.Datatype === "RadioButtonWithRichText" ||
                        q.Datatype === "Dropdown")
            ).map((q) => {
                return {
                    code: q.LoadBindName?.replace(/\s/g, ""),
                    description: this.props.isEng ? q.ENUTitle : q.FRATitle
                };
            });
                elementListWithOptions.push(...list);
        });


        if (!this.props.formSubSections.FilterValue) {
            this.props.formSubSections.FilterValue = [];
        }


        if (!this.props.formSubSections.FilterField) {
            this.props.formSubSections.FilterField = [];
        }

        for (let i = 0; i < elementListWithOptions.length; i++) {
            let option = elementListWithOptions[i];
            //from code to find element
            const field = getSectionElementByFieldName(option.code, this.props.formSubSections);
            const optionList = field?.ListOfLOVValues;

            // if(!Array.isArray(this.props.formSubSections.FilterValue[i])){
            //     console.log()
            //     this.props.formSubSections.FilterValue[i]=[]
            // }
            if(!Array.isArray(this.props.formSubSections.FilterField)){
                this.props.formSubSections.FilterField=[];
            }
           
            if (Array.from(this.props.formSubSections.FilterField).indexOf(option["code"]) == -1) {
                this.props.formSubSections.FilterField.push(option["code"])
            }

            // prune filter values that no longer exist on the source field
            const currentValues = Array.isArray(this.props.formSubSections.FilterValue[i]) ? this.props.formSubSections.FilterValue[i] : [];
            const validCodes = (optionList || []).map(v => v.code);
            const sanitizedValues = currentValues.filter(v => validCodes.includes(v));
            if (sanitizedValues.length !== currentValues.length) {
                this.props.formSubSections.FilterValue[i] = sanitizedValues;
                this.props.callback();
            }

            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{option["description"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                {/* @ts-ignore */}
                                <MultiSelect style={{ width: '100%' }}
                                    className="ontario-dropdown-small"
                                    options={optionList}
                                    value={this.props.formSubSections.FilterValue[i]}
                                    optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                    optionValue="code"
                                    placeholder="Filtering value"
                                    onChange={(e) => {
                                        //console.log(e.value);
                                        if (Utils.isNullOrEmpty(this.props.formSubSections.FilterValue)) {
                                            this.props.formSubSections.FilterValue = [];
                                            elementListWithOptions.map(() => this.props.formSubSections.FilterValue.push([]));
                                        }
                                        if (e.value) {
                                           this.props.formSubSections.FilterValue[i] = e.value;
                                        }
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        return html;
    }
    generateContentString = () => {
        let htmlString = [];
        const programContainer = this.props.formSubSections.parent.parent as ProgramContainer;
        const listOfDuplicateSubsections = [];
        programContainer.ListOfFormSections.forEach(section => {
            if (!section.CustomizedReviewPage) {
                section.ListOfFormSubSections.forEach(subsec => {
                    if (subsec.CanBeDuplicate && subsec.ENUTitle) {
                        listOfDuplicateSubsections.push(subsec.ENUTitle);
                    }
                })
            }
        })

        htmlString.push(this.generateFilter());

            htmlString.push(
                <div style={{ width: "100%", paddingTop: "5px" }}>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSubSections.Id}>Pre Script</label>
                        </div>
                        <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                            value={this.props.formSubSections.PreScript} id={"tbl_" + this.props.formSubSections.Id}
                            onChange={(e) => { this.props.formSubSections.PreScript = e.target.value; this.props.callback() }} />
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_" + this.props.formSubSections.Id}>Post Script</label>
                        </div>
                        <div style={{ width: '60%' }}>   <InputTextarea className="ontario-input"
                            value={this.props.formSubSections.PostScript} id={"tbl_" + this.props.formSubSections.Id}
                            onChange={(e) => { this.props.formSubSections.PostScript = e.target.value; this.props.callback() }} />
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={`tbl_stepper_script_${this.props.formSubSections.Id}`}>Stepper Script</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <InputTextarea
                                className="ontario-input"
                                id={`tbl_stepper_script_${this.props.formSubSections.Id}`}
                                value={this.props.formSubSections.StepperScript}
                                onChange={(e) => {
                                    this.props.formSubSections.StepperScript = e.target.value;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label>Hidden</label>
                        </div>
                        <div>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.formSubSections.Visible == false}
                                onChange={(e) => { 
                                    this.props.formSubSections.Visible = !e.checked; 
                                    this.props.callback();
                                }}
                                checked={this.props.formSubSections.Visible == false} />
                        </div>
                    </div>

                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label>Can be duplicate</label>
                        </div>
                        <div>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.formSubSections.CanBeDuplicate}
                                onChange={(e) => {
                                    this.props.formSubSections.CanBeDuplicate = e.checked;
                                    this.props.callback();
                                }}
                                checked={this.props.formSubSections.CanBeDuplicate} />
                        </div>
                    </div>
                    {this.props.formSubSections.CanBeDuplicate && (
                        <div style={{ display: "flex", marginTop: '10px', marginLeft: '20px' }}>
                            <div style={{ width: '25%' }}>
                                <label>Keep duplicates editable</label>
                            </div>
                            <div>
                                {/* @ts-ignore */}
                                <Checkbox value={this.props.formSubSections.KeepDuplicatesEditable}
                                    onChange={(e) => {
                                        this.props.formSubSections.KeepDuplicatesEditable = e.checked;
                                        this.props.callback();
                                    }}
                                    checked={this.props.formSubSections.KeepDuplicatesEditable} />
                            </div>
                        </div>
                    )}
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label>Image</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {!this.props.formSubSections.displayInEditor && <Editor value={this.props.formSubSections.Image} style={{ height: 'auto' }}
                                onTextChange={(e) => {
                                    this.props.formSubSections.Image = e.htmlValue
                                    this.props.callback();
                                }} />}
                       
                            {this.props.formSubSections.displayInEditor && <InputTextarea value={this.props.formSubSections.Image}
                                onChange={(e) => {
                                    this.props.formSubSections.Image = e.target.value;
                                    this.props.callback();
                                }} style={{ height: '100px', width: '100%' }} />}
                        <button
                            onClick={() => {
                                this.props.formSubSections.displayInEditor = !this.props.formSubSections.displayInEditor;
                                this.props.callback();
                            }} >
                            {this.props.formSubSections.displayInEditor == true ? "Raw" : "HTML"}
                        </button>
                        </div>
                    </div>
                    {this.props.formSubSections.parent.CustomizedReviewPage &&
                        <div style={{ display: "flex", marginTop: '10px' }}>
                            <div style={{ width: '25%' }}>
                                <label>Summarize duplicate subsection:</label>
                            </div>
                            <div>
                                {/* @ts-ignore */}
                                <Dropdown showClear
                                    options={listOfDuplicateSubsections}
                                    value={this.props.formSubSections.SummarizeDuplicateSubsection}
                                    onChange={(e) => {
                                        this.props.formSubSections.SummarizeDuplicateSubsection = e.value;
                                        this.props.callback();
                                    }} />
                            </div>
                        </div>}
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label>Background</label>
                        </div>
                         <div style={{ width: '60%' }}>
                            <InputTextarea className="ontario-input"
                                value={this.props.formSubSections.SubsectionBackground} id={"tbl_" + this.props.formSubSections.Id}
                                onChange={(e) => { this.props.formSubSections.SubsectionBackground = e.target.value; this.props.callback() }} />   
                        </div>
                    </div>

                    { this.props.formSubSections.parent.CustomizedReviewPage && <div style={{display: "flex", marginTop: '10px'}}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"tbl_customized_summary_text_element_style" + this.props.formSubSections.Id}>Customized report text element style</label>
                        </div>
                        <div style={{ width: '60%' }}>   
                            <Dropdown showClear
                                id={"tbl_customized_summary_text_element_style" + this.props.formSubSections.Id}
                                options={TextElementDisplayStyle}
                                value={this.props.formSubSections.CustomizedSummaryTextElementStyle}
                                onChange={(e) => {
                                    this.props.formSubSections.CustomizedSummaryTextElementStyle = e.value;
                                    this.props.callback();
                                }} />
                        </div>
                    </div>}
                    
                    { this.props.formSubSections.parent.CustomizedReviewPage && this.props.formSubSections.parent.CustomizedSummaryProps?.changeLinkInSubsectionLevel && <div style={{display: "flex", marginTop: '10px'}}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={`tbl_change_link_label_${this.props.formSubSections.Id}`}>Change link label</label>
                        </div>
                        <div style={{ width: '60%' }}>   
                            <InputText
                                className="ontario-input"
                                id={`tbl_change_link_label_${this.props.formSubSections.Id}`}
                                placeholder={this.props.isEng ? "Change" : "Modifier"}
                                value={this.props.isEng ? this.props.formSubSections.ChangeLinkProps?.changeLinkLabel : this.props.formSubSections.ChangeLinkProps?.changeLinkLabelFRA}
                                onChange={(e) => {
                                    if (this.props.formSubSections.ChangeLinkProps) {
                                        if (this.props.isEng) {
                                            this.props.formSubSections.ChangeLinkProps.changeLinkLabel = e.target.value;
                                        } else {
                                            this.props.formSubSections.ChangeLinkProps.changeLinkLabelFRA = e.target.value;
                                        }
                                    } else {
                                        if (this.props.isEng) {
                                            this.props.formSubSections.ChangeLinkProps = {changeLinkLabel: e.target.value};
                                        } else {
                                            this.props.formSubSections.ChangeLinkProps = {changeLinkLabelFRA: e.target.value};
                                        }
                                    }


                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>}
                </div>
            )

        return htmlString;
    };
  
    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    generateHtmlString = () => {
        let html = [];
        html.push(<>
        {/* @ts-ignore */}
        <Dialog header={this.props.isEng ? "Section properties for " + this.props.formSubSections.ENUTitle : "Section properties for" + this.props.formSubSections.FRATitle} footer={this.renderFooter()}
            visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
            {this.generateContentString()}
        </Dialog></>);
        return html;
    }

  
    render() {
    
        return (
            <div>
                {this.generateHtmlString()}
            </div>
        );
    }
}
